<template>
  <div class="d-flex flex-column-fluid align-items-start container-xxl">
    <!--begin::Post-->
    <div class="content flex-row-fluid">
      <!--begin::Post card-->
      <div class="card">
        <!--begin::Body-->
        <div class="card-body p-lg-20 pb-lg-0">
          <!--begin::Layout-->
          <div class="d-flex flex-column flex-xl-row">
            <!--begin::Content-->
            <div class="flex-lg-row-fluid me-xl-15">
              <!--begin::Post content-->
              <div class="mb-17" v-if="isLoaded">
                <!--begin::Wrapper-->
                <div class="mb-8">
                  <!--begin::Info-->
                  <div class="d-flex flex-wrap mb-6">
                    <!--begin::Item-->
                    <div class="me-9 my-1">
                      <!--begin::Icon-->
                      <!--begin::Svg Icon | path: icons/duotune/general/gen025.svg-->
                      <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                      </span>
                      <!--end::Svg Icon-->
                      <!--end::Icon-->
                      <!--begin::Label-->
                      <span class="fw-bolder text-gray-400">{{
                        content.date
                      }}</span>
                      <!--end::Label-->
                    </div>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <div class="me-9 my-1">
                      <router-link
                        v-if="content.user.name"
                        class="fw-bolder text-gray-400"
                        :to="{
                          name: 'psychologist',
                          params: { id: content.user.id },
                        }"
                        v-slot="{ href, navigate, isActive }"
                      >
                        <a
                          :href="href"
                          :class="{ active: isActive }"
                          @click="navigate"
                          >{{ content.user.name }}
                          {{ content.user.surname }}
                        </a>
                      </router-link>
                      <span class="fw-bolder text-gray-400" v-else>{{
                        content.user
                      }}</span>
                      <!--begin::Label-->
                    </div>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <div class="my-1"></div>
                    <!--end::Item-->
                  </div>
                  <!--end::Info-->
                  <!--begin::Title-->
                  <span class="text-dark text-hover-primary fs-2 fw-bolder">
                    {{ content.title }}</span
                  >
                  <!--end::Title-->
                  <!--begin::Container-->
                  <div class="overlay mt-8">
                    <!--begin::Image-->
                    <img
                      :src="`https://www.terapikoltugu.app/storage/blogs/${content.img}`"
                      style="width: 100%"
                      class="mw-100 mx-auto card-rounded"
                    />
                  </div>
                  <!--end::Container-->
                </div>
                <!--end::Wrapper-->
                <!--begin::Description-->
                <div
                  style="margin-bottom: 32px"
                  class="fs-5 fw-bold text-gray-600"
                  v-html="content.essey"
                ></div>
                <!--end::Description-->
                <!--begin::Block-->
                <div
                  v-if="content.user.name"
                  class="
                    d-flex
                    align-items-center
                    border-dashed
                    card-rounded
                    p-5 p-lg-10
                    mb-14
                  "
                >
                  <!--begin::Section-->
                  <div class="text-center flex-shrink-0 me-7 me-lg-13">
                    <!--begin::Avatar-->
                    <div
                      class="symbol symbol-70px symbol-circle mb-2"
                      style="cursor: pointer"
                    >
                      <img
                        @click="goProfilePage()"
                        :src="`https://www.terapikoltugu.app/storage/photos/${content.user.photo}`"
                        class=""
                        alt=""
                        style="object-fit: cover"
                      />
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Info-->
                    <div class="mb-0">
                      <router-link
                        class="text-gray-700 fw-bolder text-hover-primary"
                        :to="{
                          name: 'psychologist',
                          params: { id: content.user.id },
                        }"
                        v-slot="{ href, navigate, isActive }"
                      >
                        <a
                          :href="href"
                          :class="{ active: isActive }"
                          @click="navigate"
                          >{{ content.user.name }}
                          {{ content.user.surname }}
                        </a>
                      </router-link>
                      <span class="text-gray-400 fs-7 fw-bold d-block mt-1">{{
                        content.user.title
                      }}</span>
                    </div>
                    <!--end::Info-->
                  </div>
                  <!--end::Section-->
                  <!--begin::Text-->
                  <div class="mb-0 fs-6">
                    <div class="text-muted fw-bold lh-lg mb-2">
                      {{ content.user.about }}
                    </div>
                    <router-link
                      class="fw-bold link-primary"
                      :to="{
                        name: 'psychologist',
                        params: { id: content.user.id },
                      }"
                      v-slot="{ href, navigate, isActive }"
                    >
                      <a
                        :href="href"
                        :class="{ active: isActive }"
                        @click="navigate"
                        >Profil sayfasına göz at
                      </a>
                    </router-link>
                  </div>
                  <!--end::Text-->
                </div>
                <!--end::Block-->
                <!--begin::Icons-->
                <div class="d-flex flex-center">
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/facebook-4.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/instagram-2-1.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/github.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/behance.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/pinterest-p.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/twitter.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                  <!--begin::Icon-->
                  <a href="#" class="mx-4">
                    <img
                      src="assets/media/svg/brand-logos/dribbble-icon-1.svg"
                      class="h-20px my-2"
                      alt=""
                    />
                  </a>
                  <!--end::Icon-->
                </div>
                <!--end::Icons-->
              </div>
              <!--end::Post content-->
            </div>
            <!--end::Content-->
          </div>
          <!--end::Layout-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Post card-->
    </div>
    <!--end::Post-->
  </div>
</template>

<script>
import * as API from "@/services/";
export default {
  data() {
    return {
      experts: [],
      isLoaded: false,
      token: this.$store.getters.getAccessToken,
      params: this.$route.params,
      content: null,
    };
  },
  async created() {
    await this.getMainContent();
    this.getBlogs();
  },
  methods: {
    getMainContent: async function () {
      let vm = this;

      let experts = [];

      let response = await API.getMainContent();

      response.data.forEach((item) => {
        item.users.forEach((user) => {
          experts.push(user);
        });
      });

      vm.experts = [
        ...new Map(experts.map((item) => [item["id"], item])).values(),
      ];
    },
    getBlogs: async function () {
      let vm = this;

      let response = await API.getBlogs();
      let content = response.data.find((item) => item.id == vm.params.id);

      content.user = vm.findUser(content.user_id);
      content.date = vm.makeDate(content.created_at);

      vm.content = content;

      return (vm.isLoaded = true);
    },
    makeDate: function (date) {
      let d = new Date(date);

      let months = [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ];

      let day = d.getDate();
      let month = d.getMonth();
      let year = d.getFullYear();

      let _date = `${day < 10 ? "0" + day : day} ${months[month]} ${year}`;

      return _date;
    },
    goMessagesPage: function () {
      this.$router.push({
        name: "messageDetail",
        params: {
          id: this.psychologist.id,
        },
      });
    },
    goProfilePage: function () {
      this.$router.push({
        name: "psychologist",
        params: {
          id: this.content.user.id,
        },
      });
    },
    findUser: function (id) {
      let vm = this;

      let user = vm.experts.find((item) => item.id == id);

      if (!user) user = "Terapi Koltuğu";

      return user;
    },
  },
};
</script>